import React, { useState } from 'react'
import { Button } from 'syngenta-react-components'
import { useForm } from 'react-hook-form'
import { postProgram, patchProgram } from '../../services/apiHelper'
import TableStatus from '../subComponents/TableStatus/TableStatus'

const AddEditProgramForm = ( { handleClose, isProgramEdit, programId, programName }) => {
  const [modalStatus, setModalStatus] = useState('')
  const [programError, setProgramError] = useState(false)

  const { register, reset, handleSubmit, errors, setValue } = useForm({
    defaultValues: {
      programName: isProgramEdit ? programName : ''
    }
  })

  const onSubmit = formValues => {
    if (formValues.programName) {
      setModalStatus('LOADING')
      const paramData = {
        program_name: formValues.programName
      }
      setProgramError(false)
      if(isProgramEdit) {
        patchProgram({ ...paramData, program_id: programId }).then(response => {
          if (response?.data) {
            setModalStatus('SUCCESS')
          } else {
            setModalStatus('FAILED')
          }
        })
      } else {
        postProgram(paramData).then(response => {
          if (response?.data) {
            setModalStatus('SUCCESS')
          } else {
            setModalStatus('FAILED')
          }
        })
      }
    } else {
      setProgramError(true)
    }
  }

  let content = (
    <div className='pl16 pr16'>
      <div className='mb30'>
        <label className='fz16' htmlFor='programName'>Program Name</label>
        <div className='mb10'>
          <input
            className='bd2-s-input mt4 fz15'
            type="text"
            id='programName'
            name="programName"
            ref={register({ required: true })}
          />
          <div className='c-red tal fz12'>
            {errors.programName && errors.programName.type === 'required' ? 'Please provide program name' : programError ? 'Please provide program name': null}
          </div>
        </div>
      </div>
    </div>
  )

  const handleCloseModal = arg => {
    handleClose(arg)
    reset()
  }

  let bottomButtons = (
    <>
      <Button type='outline' text='Cancel' customClassName='mr8 miw75 pl1 pr1' clickHandler={handleCloseModal} />
      <Button type='success' text={'Save'} clickHandler={handleSubmit(onSubmit)} customClassName='miw70' />
    </>
  )

  const closeModelHandler = arg => {
    window.location.reload()
  }

  switch(modalStatus){
    case 'LOADING':
      content = (
        <>
          <p className='w100% p0'>{ isProgramEdit? 'Editing' : 'Adding' } Program In Progress. Please wait.</p>
          <TableStatus status='LOADING'/>
        </>
      )
      bottomButtons = (
        <Button disabled type='success' text='Close' clickHandler={closeModelHandler} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'SUCCESS':
      content = (
        <p className='w100% p0'>Program { isProgramEdit? 'Edited' : 'Added' }  Successfully.</p>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={() => closeModelHandler('SUCCESS')} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    case 'FAILED':
      content = (
        <p className='w100% p0'>Something went wrong. Please contact your admin.</p>
      )
      bottomButtons = (
        <Button type='success' text='Close' clickHandler={closeModelHandler} customClassName='mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4'/>
      )
      break
    default:
      break
  }

  return(
    <form className='w100% tal' onSubmit={handleSubmit(onSubmit)}>
      <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
        <div className='bb1-s-lightgray df jcsb mb16'>
          <div className='df ml15 mt15 mb15'>
            <div className='fw600'>
              { isProgramEdit? 'Edit' : 'Add' } Program
            </div>
          </div>
        </div>
        {content}
        <div className='bt1-s-lightgray df aic jcfe mt16' data-testid='newCompanyButtons'>
          <div className='mt10 mb8 mr15'>
            {bottomButtons}
          </div>
        </div>
      </div>
    </form>
  )
}

export default AddEditProgramForm